import { XIAOCAI_BRAND_TOKENS } from './brandTokens'

export const XIAOCAI_CHAT_ANTD_THEME = {
  token: {
    borderRadius: 10,
    colorPrimary: XIAOCAI_BRAND_TOKENS.primary,
    colorInfo: XIAOCAI_BRAND_TOKENS.primary,
    colorLink: XIAOCAI_BRAND_TOKENS.primaryHover,
  },
} as const

export const XIAOCAI_CHAT_THEME_TOKENS = {
  appBg: '#ffffff',
  appBorder: XIAOCAI_BRAND_TOKENS.primaryBorderSoft,
  appShadow: `0 16px 40px rgba(${XIAOCAI_BRAND_TOKENS.primaryShadowRgb}, 0.10)`,
  sidebarBg: XIAOCAI_BRAND_TOKENS.sidebarBg,
  panelBg: '#ffffff',
  divider: XIAOCAI_BRAND_TOKENS.primaryBorderSoft,
  surfaceBg: '#ffffff',
  surfaceBgActive: XIAOCAI_BRAND_TOKENS.primarySoft,
  surfaceBorder: XIAOCAI_BRAND_TOKENS.primaryBorderSoft,
  surfaceBorderActive: XIAOCAI_BRAND_TOKENS.primary,
  textPrimary: '#0f172a',
  textSecondary: '#475569',
  textMuted: XIAOCAI_BRAND_TOKENS.textMuted,
  textInverse: '#ffffff',
  iconNeutral: XIAOCAI_BRAND_TOKENS.iconNeutral,
  iconMuted: XIAOCAI_BRAND_TOKENS.iconMuted,
  bubbleUserBg: XIAOCAI_BRAND_TOKENS.primary,
  bubbleAssistantBg: '#ffffff',
  bubbleAssistantBorder: XIAOCAI_BRAND_TOKENS.primaryBorderSoft,
  bubbleUserSubtleText: XIAOCAI_BRAND_TOKENS.primarySubtleText,
  composerBg: '#f8f5ff',
  composerBoxBg: '#ffffff',
  inputText: '#0f172a',
  fileTagBg: `rgba(${XIAOCAI_BRAND_TOKENS.primaryRgb}, 0.12)`,
  fileTagBorder: `rgba(${XIAOCAI_BRAND_TOKENS.primaryRgb}, 0.28)`,
  fileTagText: XIAOCAI_BRAND_TOKENS.primaryStrong,
  scenarioBg: '#ffffff',
  scenarioCardBg: '#ffffff',
  scenarioCardBgActive: XIAOCAI_BRAND_TOKENS.primarySoft,
  scenarioCardBorder: XIAOCAI_BRAND_TOKENS.primaryBorderSoft,
  scenarioCardBorderActive: XIAOCAI_BRAND_TOKENS.primary,
  focusOutline: `0 0 0 3px rgba(${XIAOCAI_BRAND_TOKENS.primaryRgb}, 0.18)`,
} as const
